import { render, staticRenderFns } from "./SocketsRealTimeTable.vue?vue&type=template&id=2d796c28&scoped=true"
import script from "./SocketsRealTimeTable.vue?vue&type=script&lang=js"
export * from "./SocketsRealTimeTable.vue?vue&type=script&lang=js"
import style0 from "./SocketsRealTimeTable.vue?vue&type=style&index=0&id=2d796c28&prod&lang=scss"
import style1 from "./SocketsRealTimeTable.vue?vue&type=style&index=1&id=2d796c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d796c28",
  null
  
)

export default component.exports